import GeoAction from '../../prat_actions/gt/geoAction'

const GeoReducer = (state = {isGeographicLoading: true  }, action ) => {
    switch (action.type) {
        case GeoAction.GEO_REGIONS_REQUEST :
            return {
                ...state,
                isGeographicLoading:false,
            };

        case GeoAction.GEO_REGIONS_SUCCESS :
            return {
                ...state,
                isGeographicLoading:false,
                geoRegions: action.data
            };

        case GeoAction.GEO_REGIONS_FAILED :
            return {
                ...state,
                isGeographicLoading:false,
                error:action.error
            };

        // Areas

        case GeoAction.GEO_AREAS_REQUEST :
            return {
                ...state,
                isGeographicLoading:false,
            };

        case GeoAction.GEO_AREAS_SUCCESS :
            return {
                ...state,
                isGeographicLoading:false,
                geoAreas: action.data
            };

        case GeoAction.GEO_AREAS_FAILED :
            return {
                ...state,
                isGeographicLoading:false,
                error:action.error
            };

             // Towns

        case GeoAction.GEO_TOWNS_REQUEST :
            return {
                ...state,
                isGeographicLoading:false,
            };

        case GeoAction.GEO_TOWNS_SUCCESS :
            return {
                ...state,
                isGeographicLoading:false,
                geoTowns: action.data
            };

        case GeoAction.GEO_TOWNS_FAILED :
            return {
                ...state,
                isGeographicLoading:false,
                error:action.error
            };

// direct customer
            case GeoAction.GET_DIRECT_CUSTOMER_REQUEST  :
                return {
                    ...state,
                    isGeographicLoading:false,
                };
    
            case GeoAction.DIRECT_CUSTOMER_SUCCESS :
                return {
                    ...state,
                    isGeographicLoading:false,
                    directcustomer: action.data
                };
    
            case GeoAction.DIRECT_CUSTOMER_FAILED :
                return {
                    ...state,
                    isGeographicLoading:false,
                    error:action.error
                };

            // SUB DISTRIBUTORS

        case GeoAction.GEO_DISTRIBUTORS_REQUEST :
            return {
                ...state,
                isGeographicLoading:false,
            };

        case GeoAction.GEO_DISTRIBUTORS_SUCCESS :
            return {
                ...state,
                isGeographicLoading:false,
                geoDistributors: action.data
            };

        case GeoAction.GEO_DISTRIBUTORS_FAILED :
            return {
                ...state,
                isGeographicLoading:false,
                error:action.error
            };

               // SUB DISTRIBUTORS ON RESGION

        case GeoAction.GEO_DISTRIBUTORS_ON_RESGIONS_REQUEST :
            return {
                ...state,
                isGeographicLoading:false,
            };

        case GeoAction.GEO_DISTRIBUTORS_ON_RESGIONS_SUCCESS :
            return {
                ...state,
                isGeographicLoading:false,
                geoDistributorsOnResgion: action.data
            };

        case GeoAction.GEO_DISTRIBUTORS_ON_RESGIONS_FAILED :
            return {
                ...state,
                isGeographicLoading:false,
                // error:action.error,
                geoDistributorsOnResgion:action.error
            };

        default :
          return {
              ...state
          };
        //   break;
    }
}

export default GeoReducer;